import { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import t from '../../../text';
import useScrollToTop from '../../hooks/useScrollToTop';
import { fetchBlogPost, selectBlogError, selectBlogLoading, selectBlogSpecific } from '../../redux/blog/blogSlice';
import { decodeHtml } from '../../utils/string';
import { PageTitle } from '../PageTitle';
import { SearchBox } from '../SearchBox/SearchBox';
import { Spinner } from '../Spinner';
import { transformContent } from './util';

export const BlogPost = () => {
  useScrollToTop();
  const { blogPost } = useParams();
  const dispatch = useDispatch();
  const blogData = useSelector(selectBlogSpecific(blogPost));
  const loading = useSelector(selectBlogLoading);
  const error = useSelector(selectBlogError);
  const title = blogData?.title?.rendered ? decodeHtml(blogData?.title?.rendered) : t('global.loading');
  const headerImage = blogData?.pageHeaderImage || blogData?.cardHeaderUrl;

  useEffect(() => {
    if (!blogData) {
      dispatch(fetchBlogPost(blogPost)); // Fetch only if the post is not in Redux store
    }
  }, [blogPost, dispatch, blogData]);

  return (
    <>
      <SearchBox />
      {headerImage && (
        <div className="blog-post-header-image">
          <img src={headerImage} className="full-image" />
        </div>
      )}
      <PageTitle title={error ? 'Error' : title} />
      <Container className="blog-content-container" style={{ minHeight: '300px' }}>
        {error && <p>Could not find data for this blog</p>}
        {!error && loading && <Spinner />}
        {blogData && !loading && <div>{transformContent(blogData.content.rendered)}</div>}
      </Container>
    </>
  );
};
